import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { ngayNghiApi } from "../../../api/ngayNghiApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
    eNgayNghiActionTypeIds,
    INgayNghiDeleteStart,
    INgayNghiLoadStart,
    INgayNghiSaveStart,
} from "../../action-types/danh-muc/INgayNghiActionTypes";
import { actions } from "../../actions/actionsWrapper";

function* loadNgayNghiWorker(_action: INgayNghiLoadStart): any {
    const res: IBaseResponeModel = yield call([ngayNghiApi, ngayNghiApi.selectAll]);
    if (res && res.is_success) {
        yield put(actions.danhMucWrapper.ngayNghi.LOAD_SUCCESS(res.data));
    } else {
        yield put(actions.danhMucWrapper.ngayNghi.LOAD_ERROR(res?.message || "Không tải được danh sách ngày nghỉ"));
    }
}

function* saveNgayNghiWorker(action: INgayNghiSaveStart): any {
    let res: IBaseResponeModel;
    if (action.payload.id > 0) {
        res = yield call([ngayNghiApi, ngayNghiApi.update], action.payload);
    } else {
        res = yield call([ngayNghiApi, ngayNghiApi.insert], action.payload);
    }
    if (res && res.is_success) {
        yield put(actions.danhMucWrapper.ngayNghi.SAVE_SUCCESS(undefined));
    } else {
        yield put(actions.danhMucWrapper.ngayNghi.SAVE_ERROR(res?.message || "Không lưu được ngày nghỉ"));
    }
}

function* deleteNgayNghiWorker(action: INgayNghiDeleteStart): any {
    const res: IBaseResponeModel = yield call([ngayNghiApi, ngayNghiApi.delete], action.payload);
    if (res && res.is_success) {
        yield put(actions.danhMucWrapper.ngayNghi.DELETE_SUCCESS(undefined));
    } else {
        yield put(actions.danhMucWrapper.ngayNghi.DELETE_ERROR(res?.message || "Không xoá được ngày nghỉ"));
    }
}

export function* ngayNghiSaga(): any {
    yield takeLatest(eNgayNghiActionTypeIds.LOAD_START, loadNgayNghiWorker);
    yield takeEvery(eNgayNghiActionTypeIds.SAVE_START, saveNgayNghiWorker);
    yield takeEvery(eNgayNghiActionTypeIds.DELETE_START, deleteNgayNghiWorker);
}
